<template>
  <div>
    <Head title="Tasks" />
    <div class="mb-6 grid grid-cols-4 gap-4">
      <div>
        <h1 class="mb-8 text-3xl font-bold">Tasks <span v-if="form.completedFilter === 'upcoming'"> - Upcoming</span><span v-if="form.completedFilter === 'past'"> - Past</span></h1>
      </div>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md w-full" @reset="reset">
        <div v-if="auth.user.owner" class="pb-4">
          <label class="block text-gray-700 font-bold">Loan Officer:</label>
          <select v-model="form.loanOfficerFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="all">All Loan Officers</option>
            <option v-for="lo in loanOfficerFilterList" :key="lo.id" :value="lo.id">{{ lo.first_name }} {{ lo.last_name }}</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Type:</label>
          <select v-model="form.typeFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="email">Email</option>
            <option value="reminder">Reminder</option>
            <option value="text">SMS</option>
            <option value="voicemail">Voicemail</option>
            <option value="status">Status</option>
            <option value="tag">Tag</option>
            <option value="alert">Alert</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Due Date:</label>
          <select v-model="form.completedFilter" class="mt-1 w-full form-select">
            <option value="upcoming">Upcoming Date</option>
            <option value="past">Past Date</option>
          </select>
        </div>
        <div class="pb-4">
          <label class="block text-gray-700 font-bold">Target:</label>
          <select v-model="form.targetFilter" class="mt-1 w-full form-select">
            <option value="leads">Leads Only</option>
            <option value="contacts">Contacts</option>
          </select>
        </div>
      </search-filter>
      <!-- <Task :lead="lead" /> -->
    </div>




    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="hidden md:block mt-2">
              <input v-model="allSelected" type="checkbox" class="m-2 w-5 h-5 ml-3" @click="selectAll" />
              <div v-if="selected.length !== 0">
                <button class="cursor-pointer py-2" tabindex="-1" type="button" @click="deleteSelectedTasks()">
                  <i class="ml-4 far fa-trash-alt text-red-500 mr-1 text-xl" />
                </button>
              </div>
            </th>
            <th class="pb-4 pt-6 px-6">Due Date</th>
            <th class="pb-4 pt-6 px-6">Target</th>
            <th class="pb-4 pt-6">Type</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Message</th>
            <th class="pb-4 pt-6 px-6">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="task in processedTasks" :id="task.id + 'row'" :ref="task.id + 'row'" :key="task.id"
              class="even:bg-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="hidden md:block md:border-t">
              <input
                :id="task.id"
                v-model="selected"
                type="checkbox"
                :value="task.id"
                class="hidden md:block m-4 w-4 h-4"
                @click="select(task.id)"
              />
            </td>
            <td class="border-t">
              <div class="ml-5">
                <div class="flex py-1">
                  <div class="text-sm mr-2">
                    {{ task.date }}
                  </div>
                  <div class="text-sm">
                    {{ task.time }}
                  </div>
                  <div>
                    <button class="cursor-pointer ml-2" tabindex="2" type="button"
                      @click="remindTomorrow(task.id)"
                      title="Add a day then remind me."
                    >
                      <i class="fas fa-angle-double-right mr-3 text-green-500" />
                    </button>
                  </div>
                </div>
                <div v-if="task.past_due === true" class="w-full text-sm text-red-500 py-1">
                  <i class="fas fa-exclamation-circle" />  {{ task.readable }}
                </div>
                <div v-if="task.past_due === false" class="w-full text-indigo-500 text-sm py-1">
                  <i class="far fa-clock" /> {{ task.readable }}
                </div>
              </div>
            </td>
            <td class="border-t">
              <div class="w-full text-m my-2">
                <div class="w-full flex text-sm py-1">
                  <Link v-if="task.lead_id" class="flex px-6 focus:text-indigo-500"
                        :href="`/leads/${task.lead_id}/edit`">
                    <!-- <i class="fas fa-users text-green-500 mr-2 text-xl" /> -->
                    <div class="font-semibold text-m">{{ task.name }}</div>
                  </Link>
                  <Link v-if="task.contact_id" class="flex px-6 focus:text-indigo-500"
                        :href="`/contacts/${task.contact_id}/edit`">
                    <!-- <i class="far fa-address-card text-blue-500 mr-2 text-xl" /> -->
                    <div class="font-semibold text-m">{{ task.name }}</div>
                  </Link>
                </div>
              </div>
            </td>
            <td class="border-t">
              <div class="text-center">
                <IconNotes :name="task.type" />
              </div>
            </td>
            <td class="border-t" colspan="2">
              <div class="w-full text-m my-2">
                <div v-if="task.type === 'email'" class="pb-1">
                  Subject: {{ task.subject }}
                </div>
                <div v-if="task.type !== 'status'">
                  {{ truncate(task.message, 100, '...') }}
                </div>
                <div v-if="task.type === 'status'">
                  Status Change to: {{ task.subject }}
                </div>
              </div>
            </td>
            <td class="border-t text-right">
              <div class="flex justify-end md:text-right text-xl my-2 mr-5">
                <Link v-if="task.contact_id" class="cursor-pointer py-2"
                      :href="`/contacts/${task.contact_id}/edit`"
                      title="View Contact">
                  <i class="far fa-user text-green-500 mr-3" />
                </Link>
                <Link v-if="task.lead_id" class="cursor-pointer py-2"
                      :href="`/leads/${task.lead_id}/edit`"
                      title="View Lead">
                  <i class="far fa-user text-green-500 mr-3" />
                </Link>
                <TaskEdit :task="task">
                  <template #buttonTop>
                    <button class="cursor-pointer py-2" title="Edit Task"> <i
                      class="far fa-edit text-indigo-500" /></button>
                  </template>
                </TaskEdit>
                <button
                  class="cursor-pointer py-2 mr-2" tabindex="1" type="button"
                  @click="destroyTask(task.id)"
                  title="Delete Task"
                >
                  <i class="ml-2 far fa-trash-alt text-red-500 mr-1" />
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="tasks.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No tasks found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap justify-between align-center">
      <div class="pb-4 mt-6">
        <label class="block text-gray-700 font-bold">Per Page:</label>
        <select v-model="form.perPageFilter" class="mt-1 form-select">
          <option :value="null" />
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="150">150</option>
          <option value="200">200</option>
          <option value="250">250</option>
          <option value="500">500</option>
        </select>
      </div>
      <pagination class="mt-6" :links="tasks.links" />
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import Task from '@/Shared/Task'
import TaskEdit from '@/Shared/TaskEdit'
import IconNotes from '@/Shared/IconNotes'

export default {
  components: {
    Head,
    Task,
    Link,
    Pagination,
    SearchFilter,
    TaskEdit,
    IconNotes,
  },
  layout: Layout,
  props: {
    filters: Object,
    tasks: Object,
    auth: Object,
    loanOfficerFilterList: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        completedFilter: this.filters.completedFilter,
        targetFilter: this.filters.targetFilter,
        typeFilter: this.filters.typeFilter,
        loanOfficerFilter: this.filters.loanOfficerFilter,
      },
      selected: [],
      allSelected: false,
    }
  },
  computed: {
    processedTasks() {
      return this.tasks.data.map(task => {
        const updatedMessage = task.message.replace(/%fullName%/g, task.name)
        return {
          ...task,
          message: updatedMessage,
        }
      })
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get('/tasks', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    selectAll() {
      if (this.allSelected) {
        // Deselect all tasks
        this.selected = []
      } else {
        // Select all tasks that have a phone property
        this.selected = this.tasks.data
          .map(task => task.id)
      }
      // Toggle the allSelected state
      this.allSelected = !this.allSelected
    },
    select(taskId) {
      const index = this.selected.indexOf(taskId)

      if (index === -1) {
        // Add taskId to selected array
        this.selected.push(taskId)
      } else {
        // Remove taskId from selected array
        this.selected.splice(index, 1)
      }

      // Update allSelected state based on whether all tasks are selected
      this.allSelected = this.tasks.data
        .every(task => this.selected.includes(task.id))
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      }
      return text
    },
    destroyTask(id) {
      if (confirm('Are you sure you want to delete this task?')) {
        router.delete(`/tasks/${id}`, {
          only: ['tasks'],
          preserveScroll: true,
        })
      }
    },
    deleteSelectedTasks() {
      if (this.selected.length === 0) {
        alert('No tasks selected.')
        return
      }

      if (confirm(`Are you sure you want to delete ${this.selected.length} selected tasks?`)) {
        // Perform bulk deletion
        this.selected.forEach(taskId => {
          router.delete(`/tasks/${taskId}`, {
            only: ['tasks'],
            preserveScroll: true,
          })
        })

        // Clear the selected array and uncheck 'allSelected'
        this.selected = []
        this.allSelected = false

      }
    },
    remindTomorrow(taskId) {
      router.put(`/tasks/${taskId}/remind-tomorrow`, {}, {
        only: ['tasks'],
        preserveScroll: true,
        preserveState: true,
      })
    },
  },
}
</script>
